import { SET_DATA_KEY } from '../../constants'

export function getCountKeySetDataUtil (set) {
  if (!set) {
    return
  }

  if (set[SET_DATA_KEY.REPS] != null) {
    return SET_DATA_KEY.REPS
  }

  if (set[SET_DATA_KEY.TIME] != null) {
    return SET_DATA_KEY.TIME
  }

  return SET_DATA_KEY.REST
}
